module.exports = "/assets/site/images/mvmse_logo_right_transparent.png?1d002c52e55d23f0afa9ea9dba20f3d6";